import Commons from '../../../Services/Common/Common';

export const HEL_BASIC_Schema = {
  mapper: {
    search1: {
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd || ''
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.custCd || ''
            : context.userInfo?.custCd || context.search?.custCd || ''
        ) || '',
      CategoryCd: (_, context) =>
        Commons.EncryptAES(context.search?.categoryCd || '') || '',
      StatusCd: (_, context) => Commons.EncryptAES(context.search?.statusCd || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
    },
    search2: {
      HdBoardNo: (_, context) =>
        Commons.EncryptAES(
          String(context.row?.hdBoardNo || context.row?.HdBoardNo || 0)
        ) || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
    },
    search3: {
      HdBoardNo: (_, context) =>
        Commons.EncryptAES(
          String(context.row?.hdBoardNo || context.row?.HdBoardNo || 0)
        ) || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
    },
    save1: {
      HdBoardNo: (row) => Commons.EncryptAES(String(row?.hdBoardNo || 0)) || '',
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd || ''
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || context.userInfo?.custCd || '') || '',
      CategoryCd: (row) => Commons.EncryptAES(row?.categoryCd || 'QNA') || '',
      ScreenNm: (row) => Commons.EncryptAES(row?.screenNm || '') || '',
      Title: (row) => Commons.EncryptAES(row?.title || '') || '',
      Content: (row) => Commons.EncryptAES(row?.content || '') || '',
      FileName: (row) => Commons.EncryptAES(row?.fileName || '') || '',
      SaveName: (row) => Commons.EncryptAES(row?.saveName || '') || '',
      FilePath: (row) => Commons.EncryptAES(row?.filePath || '') || '',
      StatusCd: (row) => Commons.EncryptAES(row?.statusCd || '10') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
    },
    save2: {
      HdBoardNo: (row) => Commons.EncryptAES(String(row?.hdBoardNo || 0)) || '',
      StatusCd: (row) => Commons.EncryptAES(row?.statusCd || '10') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
    },
    save3: {
      HdBoardNo: (row) => Commons.EncryptAES(String(row?.hdBoardNo || 0)) || '',
      Content: (row) => Commons.EncryptAES(row?.content || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
    },
    delete1: {
      HdBoardNo: (row) => Commons.EncryptAES(String(row?.hdBoardNo || 0)) || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) => Commons.EncryptAES(context.userInfo?.authCd || '') || '',
    },
  },
};
